import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-at";

/**
 * Lazy import that survives stale build hashes after a new deploy.
 * If the chunk can't be fetched, retry once, then hard-reload the page once.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (error) {
      // Second chance: transient network hiccup
      try {
        return await factory();
      } catch (retryError) {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
        if (Date.now() - last > 15000) {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          // Keep the promise pending while the page reloads
          return new Promise<{ default: T }>(() => {});
        }
        throw retryError;
      }
    }
  });
}
